export default __webpack_public_path__ + "static/media/money-back.2f33b352.png";